import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ServicioPulseraService,
  ReportePulseraEntity
} from 'src/app/services/servicio-pulsera.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reporte-pulsera',
  templateUrl: './reporte-pulsera.component.html',
  styleUrls: ['./reporte-pulsera.component.css']
})
export class ReportePulseraComponent implements OnInit {
  @ViewChild('qr') public qr: any;

  public qrCodeParam = '';
  public fechaAdmision: any;
  public tamanoNombre: number;
  public entityPulsera: ReportePulseraEntity = {
    id: 0,
    id_pre_admision: '',
    identificacion: '',
    tipo_documento: '',
    nombre: '',
    apellido: '',
    sexo: '',
    edad: '',
    fecha_pre_admision: new Date(),
    grupo_sanguineo: ''
  };

  constructor(private activatedRoute: ActivatedRoute, private servicePulsera: ServicioPulseraService) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((param: any) => {
      this.getDataPulsera(param.codigoBaseDatos, param.idAdm);
    });
  }

  public print() {
    window.print();
  }

  private async getDataPulsera(code: string, id: string) {
    const result = await this.servicePulsera.getResponse(code, id);

    result.subscribe(
      (data: any) => {
        this.entityPulsera = data;
        if (this.entityPulsera.grupo_sanguineo === '-1' || this.entityPulsera.grupo_sanguineo === undefined) {
          this.entityPulsera.grupo_sanguineo = '-';
        }

        this.tamanoNombre = `${this.entityPulsera.nombre} ${this.entityPulsera.apellido}`.length;

        this.fechaAdmision = new Date(this.entityPulsera.fecha_pre_admision);
        this.qrCodeParam = `${this.entityPulsera.id_pre_admision} ${this.entityPulsera.nombre} ${this.entityPulsera.apellido} ${this.entityPulsera.tipo_documento} ${this.entityPulsera.identificacion} ${this.entityPulsera.edad} ${this.entityPulsera.grupo_sanguineo}`;
      },
      error => {
        console.log(error);
      }
    );
  }
}
